export default {
  feedTopBadge: {
    id: 'feedTopBadge.artist',
    defaultMessage: 'Artist',
  },
};
